module.exports = __webpack_public_path__ + "img/電気回路_5_6_3.e360377d.png";